<template>
  <div>
    <el-dialog :visible.sync="centerDialogVisiblefavicon" width="45%" center>
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Favicon Logo
        </h3></template
      >
      <div class="p-3">
        <el-upload
          class="upload-demo"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
          :accept="['image/jpg', 'image/jpeg', 'image/png']"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div>
        </el-upload>
        <div class="grid grid-cols-3 items-center gap-4 mt-6 cust-overflow">
          <div
            class="img_wrap"
            v-for="(item, index) in Fetchedmedias"
            :key="('item-', +index)"
            @click="faviconclick(item)"
            v-show="item.type != 'video'"
          >
            <div>
              <div>
                <img
                  :src="url1 + item.link"
                  alt="image"
                  class="w-full object-cover rounded-4px h-72px cursor-pointer"
                />
              </div>
            </div>

            <!-- <div class="previewselect" v-if="FaviconMedia._id == item._id">
              <feather-icon
                icon="CheckIcon"
                svgClasses="w-8 h-8"
                class="text-success font-semibold"
              />
            </div> -->
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="100"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="isShowadmin" width="50%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Add Blogs
        </h3></template
      >
      <div class="px-4">
        <div class="">
          <label>Image Upload</label>

          <el-input
            placeholder="Input Image"
            class="w-full mt-2"
            v-model="imageSource"
          ></el-input>
          <button @click="centerDialogVisiblefavicon = true">edit image</button>
          <!-- image preview -->
          <div class="grid grid-cols-3 gap-4 mt-4">
            <!-- <div class="relative" v-if="imageSource">
              <img
                :src="imageSource ? imageSource : ''"
                class="w-full h-32 bg-gray"
              />
              <div class="absolute top-0 right-0 m-2">
                <div
                  class="cross bg-white rounded-full"
                  v-if="datavalue || imageSource"
                >
                  <feather-icon
                    icon="XIcon"
                    svgClasses="w-3 h-3"
                    class="cursor-pointer"
                    @click="
                      () => {
                        this.datavalue = '';
                        this.imageSource = '';
                      }
                    "
                  />
                </div>
              </div>
            </div> -->
            <!-- update-->
          </div>
        </div>
        <p v-if="submitted == true" class="fsize12 text-danger">
          {{ imageSource === "" ? "This Field is required" : "" }}
        </p>
        <div class="mt-4">
          <label>Select Category Name</label>
          <el-select
            multiple
            v-model="value"
            value-key="_id"
            placeholder="Select"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in options"
              :key="item._id"
              :label="item.categoryName"
              :value="item._id"
            >
            </el-option>
          </el-select>

          <p v-if="submitted == true" class="fsize12 text-danger">
            {{ value.length === 0 ? "This Field is required" : "" }}
          </p>
        </div>
        <div class="mt-4">
          <label>Title</label>
          <el-input
            placeholder="Please input"
            class="w-full mt-2"
            v-model="input"
          ></el-input>
          <p v-if="submitted == true" class="fsize12 text-danger">
            {{ input === "" ? "This Field is required" : "" }}
          </p>
        </div>
        <div class="mt-4">
          <label>Description</label>
          <quill-editor
            v-model="mailMessage"
            :options="editorOption"
            class="quill-h200px mt-2"
          />
          <p v-if="submitted == true" class="fsize12 text-danger">
            {{ mailMessage === "" ? "This Field is required" : "" }}
          </p>
        </div>

        <div class="mt-4">
          <label>Status</label>
          <div class="flex items-center gap-2 mt-2">
            <el-radio-group v-model="radio">
              <el-radio :label="true">Active</el-radio>
              <el-radio :label="false">Inactive</el-radio>
            </el-radio-group>
          </div>
          <p v-if="submitted == true" class="fsize12 text-danger">
            {{ radio === "" ? "This Field is required" : "" }}
          </p>
        </div>
        <div class="mt-8 flex justify-center w-full">
          <vs-button
            variant="primary"
            class="px-12 py-3 text-white bg-primary cursor-pointer"
            @click="createBlogs"
            v-if="submitButton"
          >
            Submit</vs-button
          >
          <vs-button
            v-if="updateButton"
            variant="primary"
            class="px-12 py-3 text-white bg-primary cursor-pointer"
            @click="updateBlogsData(editBlogs._id)"
          >
            Update</vs-button
          >
        </div>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Blogs
          </h2>
        </div>
      </div>
    </div>
    <div class="p-8 fixed-top menucontrol-scroll pb-32 bg-white">
      <div class="w-full flex justify-end">
        <vs-button
          color="primary"
          @click="
            () => {
              submitted = false;
              isShowadmin = true;
            }
          "
          class="px-12 py-3 text-white bg-primary cursor-pointer"
          >Add Blogs</vs-button
        >
      </div>

      <el-table
        :data="tableData"
        :row-key="getRowKey"
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-colorpd"
        border
      >
        <el-table-column
          prop="id"
          type="index"
          label="Sr No."
          min-width="120px"
        >
        </el-table-column>
        <el-table-column label="Image" min-width="40px">
          <template slot-scope="scope">
            <div class="">
              <img
                v-if="scope.row.image"
                :src="
                  scope.row.image ? showImageurl + '/' + scope.row.image : ''
                "
                class="w-10 h-10"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="Heading" width="180">
        </el-table-column>
        <el-table-column label="Date" width="180">
          <template slot-scope="scope">
            {{
              ((d = new Date(scope.row.postDate)),
              d.toLocaleDateString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }))
            }}
          </template>
        </el-table-column>
        <el-table-column label="Category">
          <template slot-scope="scope">
            <div class="flex flex-wrap">
              <p
                v-for="category in scope.row.categoryID"
                :key="category._id"
                class="pr-2"
              >
                <el-tag
                  class="text-gray rounded-full el-tag el-tag--success el-tag--light"
                >
                  {{ category.categoryName }}</el-tag
                >
              </p>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Status" min-width="50px">
          <template slot-scope="scope">
            {{ scope.row.content }}
          </template>
        </el-table-column> -->
        <el-table-column label="Status" min-width="50px">
          <template slot-scope="scope">
            <P
              :class="`${
                scope.row.isActive === true ? 'text-success' : 'text-danger'
              }`"
              >{{ scope.row.isActive === true ? "Active" : "InActive" }}</P
            >
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Options" min-width="40px">
          <template slot-scope="scope">
            <div class="flex gap-2 items-center">
              <feather-icon
                icon="Edit2Icon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="editBlogData(scope.row)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="deleteBlogs(scope.row._id)"
              />
              <feather-icon
                icon="ExternalLinkIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="RedirectBlogs(scope.row._id)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="w-full flex justify-end mt-6">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="
            (value) => {
              currentPage = value;
              getBlogs();
            }
          "
          :per-size="perPage"
          :total="totalUsers"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import axios from "axios";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.core.css";
import type, { UploadProps, UploadUserFile } from "element-ui";
import "quill/dist/quill.snow.css";
import { ref } from "vue";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      radio: ref(""),
      value1: new Date().toLocaleDateString(),
      input: "",
      value: [],
      mailMessage: "",
      editorOption: {},
      tableData: [],
      totalUsers: 0,
      currentPage: 1,
      perPage: 10,
      editBlogs: [],
      isShowadmin: false,
      options: [],
      submitButton: true,
      updateButton: false,
      Fetchedmedias: [],
      imageUpdate: false,
      url1: this.$imageURL,
      imageForSubmit: false,
      imageSource: "",
      submitted: false,
      centerDialogVisiblefavicon: false,
      showImageurl: process.env.VUE_APP_IMAGE_URL,
    };
  },
  watch: {
    isShowadmin(newValue) {
      if (!newValue) {
        this.onClick();
        this.getBlogs();
      }
    },
    input() {
      this.whitespaceRemove();
    },
    // tableData(val) {
    //   if (val.length === 0) {
    //     this.getBlogs();
    //   }
    // },
  },
  methods: {
    getRowKey(row) {
      // console.log(row);
      return row._id;
    },
    onClick() {
      this.imageUpdate = false;
      this.imageForSubmit = true;
      // this.isShowadmin = true;
      this.submitButton = true;
      this.updateButton = false;
      this.imageSource = "";
      this.imageSource = "";
      this.value = "";
      this.radio = "";
      this.value1 = "";
      this.mailMessage = "";
      this.input = "";
    },
    async createBlogs() {
      // const formData = new FormData();
      let category = [];
      let payload = {
        title: this.input,
        postDate: new Date().toLocaleDateString(),
        content: this.mailMessage,
        image: this.imageSource ? this.imageSource : null,
        isActive: this.radio,
        categoryID: this.value,
      };
      // formData.append("title", this.input),
      //   formData.append("postDate", new Date().toLocaleDateString());
      // formData.append("content", this.mailMessage);
      // formData.append(`image`, this.imageSource ? this.imageSource : null);
      // formData.append("isActive", this.radio);

      // formData.append("images", this.images);
      this.submitted = true;
      if (
        this.input !== "" &&
        this.mailMessage !== "" &&
        this.imageSource !== "" &&
        this.radio !== "" &&
        this.value !== ""
      ) {
        await this.$store.dispatch("blogs/createBlogs", payload);
        this.$swal({
          text: "Blog Successfully Created",
          icon: "success",
          confirmButtonColor: "#830c81",
          // cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        });
        this.isShowadmin = false;
        this.getBlogs();
      }
    },
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.input = this.input ? this.input.trimStart() : "";
      });
    },
    async getBlogs() {
      let data = await this.$store.dispatch("blogs/getBlogs", {
        perPage: this.perPage,
        page: this.currentPage,
      });
      this.tableData = data.data.blogs;
      this.totalUsers = data.data.blogsLength;
    },
    async editBlogData(data) {
      // let index = this.tableData.blogs.findIndex((x) => x._id === id);
      this.imageSource = data.image;
      this.value1 = data.postDate;
      this.editBlogs = data;
      this.value = this.editBlogs.categoryID.map((x) => x._id);
      console.log(this.value);
      this.radio = this.editBlogs.isActive;
      this.mailMessage = this.editBlogs.content;
      this.input = this.editBlogs.title;
      // console.log(this.data.isActive, "radio");
      this.isShowadmin = true;
      this.imageUpdate = true;
      this.imageForSubmit = false;
      this.submitButton = false;
      this.updateButton = true;
    },
    faviconclick(item) {
      // image which is select from list will select in img input
      this.imageSource = item.link;
      this.centerDialogVisiblefavicon = false;
    },
    async updateBlogsData(id) {
      let payload = {
        _id: id,
      };
      let imagePayload = {
        _id: id,
      };
      if (this.input != this.editBlogs.title) {
        Object.assign(payload, { title: this.input });
      }
      let category = [this.editBlogs.categoryID];
      let categoryId = [];

      console.log(categoryId, "xsxsx");
      if (this.value !== this.editBlogs.categoryID._id) {
        Object.assign(payload, { categoryID: this.value });
      }
      if (this.imageSource) {
        Object.assign(payload, { image: this.imageSource });
      }

      if (this.radio !== this.editBlogs.isActive) {
        Object.assign(payload, { isActive: this.radio });
      }
      if (this.mailMessage != this.editBlogs.content) {
        Object.assign(payload, { content: this.mailMessage });
      }

      await this.$store.dispatch("blogs/updateBlogs", payload);
      this.isShowadmin = false;
      this.getBlogs();

      // formData.append("images", this.images);
    },
    beforeUpload(file) {
      // checking valid file
      let formData = new FormData();
      const fileType = file.type;
      formData.append("file", file);
      if (
        fileType.startsWith("image/jpeg") ||
        fileType.startsWith("image/png") ||
        fileType.startsWith("image/gif")
      ) {
        formData.append("type", "image");
      } else if (
        fileType.startsWith("video/mp4") ||
        fileType.startsWith("video/webm") ||
        fileType.startsWith("video/ogg")
      ) {
        formData.append("type", "video");
      } else if (fileType.startsWith("image/svg+xml")) {
        formData.append("type", "svg");
      } else {
        this.isShowDetailsAddons = false;
        this.$swal({
          title: "Error",
          text: `${file.type} not allowed`,
          icon: "error",
          timer: 5000,
          buttons: false,
        });
        return;
      }
      let URL = process.env.VUE_APP_BASE_URL_CORE_API.split("/api/")[0];
      formData.append("Storeendpoint", URL);
      this.uploadFile(formData, file.name);
      return false;
    },
    async uploadFile(formData, name) {
      // upload file to cloud and fetch for selection in photo list
      await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Save",
        formData,
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
      this.handleUploadSuccess(name);
    },
    async handleUploadSuccess(name) {
      // just a popup for file submited into cloud
      this.$swal({
        title: "Success!",
        text: `File ${name} uploaded`,
        icon: "success",
        timer: 2000,
        buttons: false,
      });
    },
    async Fetchmedia() {
      // for data of img list for img selection
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
      console.log(this.Fetchedmedias);
    },
    RedirectBlogs(_id) {
      window.open(
        `https://portfolio-blogs.brained.in/portfolio-blogs/blog-details/${_id}`
      );
    },
    async deleteBlogs(id) {
      this.$swal({
        text: `Are you sure you want to Delete`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then(async (value) => {
        if (value.isConfirmed == true) {
          await this.$store.dispatch("blogs/deleteBlogs", { _id: id });
          this.$swal({
            text: "Your Blog deleted successfully",
            icon: "success",
            confirmButtonColor: "#830c81",
            confirmButtonText: "OK",
          });
          this.currentPage =
            this.currentPage > 0
              ? this.currentPage - 1
              : (this.currentPage = 1);
          this.getBlogs();
        }
      });
    },
    async getCategory() {
      let payload = {
        getall: "CategoryAll",
      };
      let data = await this.$store.dispatch("blogs/getCategories", payload);
      this.options = data.data.category;
    },

    Preview(image) {
      console.log(image, "preview");
      return `${URL.createObjectURL(image)}`;
    },
  },

  mounted() {
    this.getBlogs();
    this.Fetchmedia();
    this.getCategory();
  },
};
</script>
